import React from "react";
import '../index.css';
import { NavLink } from "react-router-dom";

const Common = (props) => {
  return (
    <section id="header" className="d-flex align-items-center">
      <div className="container-fluid nav_bg">
        <div className="row">
          <div className="col-10 mx-auto">
          <div className="row">
            <div className="col-lg-6 pt-3 pt-lg-5 order-2 order-lg-1 d-flex justify-content-center flex-column">
              
              <h1>{props.name} <strong className="brand-name">COVID-19</strong> </h1>
              <h3 className="my-3">
              {props.name1}
              </h3>
              <div className="mt-3">
               <NavLink to={props.visit} className="btn btn-md" id="b">{props.btnname}</NavLink>
              </div>
            </div>
            <div class="col-lg-6 order-1 order-lg-2 header-img pt-3">
              <img src={props.imgsrc} className="img-fluid animated" alt="home-img"/>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Common;
